document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname === '/') {
    const birdContainer = document.createElement('div');
    birdContainer.id = 'bird-container';
    document.body.appendChild(birdContainer);

    function createBird() {
      const bird = document.createElement('div');
      const minHeight = 10; // Minimum height from the top of the viewport
      const maxHeight = window.innerHeight / 2; // Up to half of the viewport height
      bird.classList.add('bird');
      bird.style.top = minHeight + Math.random() * (maxHeight - minHeight) + 'px';
      bird.style.left = -50 + 'px';
      birdContainer.appendChild(bird);

      setTimeout(() => {
        birdContainer.removeChild(bird);
      }, 6000); // Keep the bird on screen for 4 seconds
    }

    createBird(); // Create the first bird immediately
    setInterval(createBird, 100000); // Create a new bird every 100 seconds
  }
});
